export enum AGREEMENT_TYPES {
  PRIVACY = 'PRIVACY',
  TERM = 'TERM',
}

export enum LANGUAGES {
  ITALIAN = 'it',
  ENGLISH = 'en',
  FRENCH = 'fr',
  GERMAN = 'de',
  SPANISH = 'es',
  DUTCH = 'nl',
}

